require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-1-kg-cy-g.json") })
        }
      }, "path---photos-professional-1-kg-cy-g");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-1-kg-cy-g!./.cache/json/photos-professional-1-kg-cy-g.json
// module id = 566
// module chunks = 231608221292675